// extracted by mini-css-extract-plugin
export var dropdown = "_uv-0";
export var imageWrapper = "_uv-3";
export var itemNameContainer = "_uv-1";
export var productImage = "_uv-2";
export var spinnerWrapper = "_uv-4";